/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why a vehicle can or cannot be swapped onto a tour, as far as is knowable without routing.  Deliberately does NOT cover \"the route cannot be built with it\": answering that means an OR-Tools solve per candidate, ten seconds each, which is not something a dropdown can wait for. The save answers it, explains itself, and lets the manager override. This enum is what the list can say instantly and truthfully — one value per rejection getTaxiVehicleSwapCandidatesForTour actually applies, mirroring TaxiAttendantChangePossibilityReason\'s reasoning for companions.
 */
export const TaxiVehicleChangePossibilityReason = {
    Available: 'Available',
    AlreadyInOtherTour: 'AlreadyInOtherTour',
    NotEnoughSeats: 'NotEnoughSeats',
    NotEnoughWheelchairSpaces: 'NotEnoughWheelchairSpaces',
    MaxPersonsExceeded: 'MaxPersonsExceeded',
    VehicleTimedOut: 'VehicleTimedOut'
} as const;
export type TaxiVehicleChangePossibilityReason = typeof TaxiVehicleChangePossibilityReason[keyof typeof TaxiVehicleChangePossibilityReason];

